var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "delete_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#delete_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.757 16.583a1.29 1.29 0 01-.946-.393 1.29 1.29 0 01-.394-.947V5.5h-.458a.526.526 0 01-.542-.538c0-.152.052-.28.156-.387a.52.52 0 01.386-.158H8v-.25a.63.63 0 01.192-.463.63.63 0 01.462-.191h2.693a.63.63 0 01.462.191.63.63 0 01.191.463v.25h3.042a.526.526 0 01.542.537.532.532 0 01-.156.387.52.52 0 01-.386.159h-.458v9.735c0 .378-.132.698-.394.958s-.578.39-.946.39H6.757zM13.5 5.5h-7v9.743a.25.25 0 00.072.185.25.25 0 00.185.072h6.487a.25.25 0 00.184-.072.25.25 0 00.072-.185V5.5zM8.874 14a.531.531 0 00.388-.156.519.519 0 00.158-.386V7.542A.526.526 0 008.883 7a.532.532 0 00-.387.156.52.52 0 00-.16.386v5.916a.526.526 0 00.538.542zm2.244 0a.532.532 0 00.387-.156.519.519 0 00.159-.386V7.542A.526.526 0 0011.126 7a.532.532 0 00-.387.156.52.52 0 00-.159.386v5.916a.526.526 0 00.538.542z",
    fill: "#7A8D8F"
  }))));
}
export default SvgDelete;